export class TechnicalApplicationModel {
  id:	string;
  name:	string;
  categoryId:	string;
  minSize:	number;
  maxSize:	number;
  iconURL:	string;
  defaultRatio:	string;
  foilCount: number;
  wet:	string;
  virginHair:	string;
  state:	string;
  calc:	string;
  lastModByID: string;
  lastModDate:	string;
  dispenseCount:	number;
}
